import "../../assets/css/panel-tile.css";
import Image from "./Image";
import { shimmerWrapper } from "../Shimmer/Shimmer";

const wrappedImage = shimmerWrapper(Image);

export { wrappedImage as Image };
  
export default wrappedImage;